// Constructie unificata a randurilor de clasificare (tematic gradual/categorial) pentru legenda de ecran si cea de print.
// Prefera clasificarea calculata la runtime (layer.thematicClassification) fata de descriptorul salvat,
// ca ambele legende sa afiseze aceleasi clase (evita divergenta legenda-ecran vs. print).

// un interval e "populat" daca are eticheta/valoare (categorial) sau macar o margine (gradual)
export function isPopulatedInterval(interval) {
    if (interval == null) {
        return false;
    }

    return (interval.label != null && interval.label !== '')
        || (interval.value != null && interval.value !== '')
        || interval.min != null
        || interval.max != null;
}

// pragurile calculate (cuantile/jenks) sunt zecimale => rotunjim pentru afisare;
// pentru valori mici pastram cifre semnificative ca sa nu colapseze clase apropiate la aceeasi eticheta;
// intoarcem mereu string zecimal (nu Number) ca sa nu apara notatie exponentiala (ex. 5e-7) in etichete
export function formatBreakValue(value) {
    if (value == null || value === '') {
        return '';
    }

    let n = Number(value);

    if (isNaN(n)) {
        return value;
    }

    if (n === 0) {
        return '0';
    }

    let abs = Math.abs(n);
    let decimals = 2;

    // valori subunitare: crestem zecimalele ca sa pastram ~3 cifre semnificative, fara exponent
    if (abs < 1) {
        decimals = Math.min(20, 2 - Math.floor(Math.log10(abs)));
    }

    let s = n.toFixed(decimals);

    // taiem zerourile inutile de dupa virgula (nu si din partea intreaga)
    if (s.indexOf('.') >= 0) {
        s = s.replace(/0+$/, '').replace(/\.$/, '');
    }

    return s;
}

// numele randului: eticheta manuala > valoare categoriala > interval numeric (cu capete deschise ≤/≥)
export function nameForInterval(interval, rangeTemplate) {
    if (interval.label != null && interval.label !== '') {
        return interval.label;
    }

    if (interval.value != null && interval.value !== '') {
        return interval.value;
    }

    let min = interval.min;
    let max = interval.max;

    if (min == null && max != null) {
        return '≤ ' + formatBreakValue(max);
    }

    if (max == null && min != null) {
        return '≥ ' + formatBreakValue(min);
    }

    let template = (rangeTemplate != null && rangeTemplate !== '' && rangeTemplate !== 'LegendIntervalTemplate') ? rangeTemplate : 'From {0} to {1}';

    return template.replaceAll('{0}', formatBreakValue(min)).replaceAll('{1}', formatBreakValue(max));
}

// intervale -> randuri {idx, name, color}; sarim intervalele nepopulate (clase in plus fata de pragurile calculate)
export function classificationsFromIntervals(intervals, rangeTemplate) {
    let result = [];

    if (intervals == null) {
        return result;
    }

    let idx = 1;

    intervals.forEach(interval => {
        if (isPopulatedInterval(interval)) {
            result.push({ idx: idx, name: nameForInterval(interval, rangeTemplate), color: interval.color });
            idx++;
        }
    });

    return result;
}

// prefera clasificarea runtime (layer.thematicClassification), altfel cade pe descriptorul salvat
export function classificationsFromLayer(layer, styles, rangeTemplate) {
    if (layer == null) {
        return [];
    }

    if (layer.thematicClassification != null && layer.thematicClassification.length > 0) {
        return classificationsFromIntervals(layer.thematicClassification, rangeTemplate);
    }

    let style = styles != null ? styles[layer.IdDefaultStyle] : null;

    if (style == null) {
        return [];
    }

    if (style.style != null) {
        style = style.style;
    }

    if ((style.Type != null && style.Type == 'TEMATIC') || (style.Intervals != null && style.Intervals.length > 1)) {
        return classificationsFromIntervals(style.Intervals, rangeTemplate);
    }

    // stil clasic cu mai multe reguli (nume per regula)
    if (style.length > 1) {
        let result = [];
        let idx = 0;

        style.forEach(styleItem => {
            result.push({ idx: idx, name: styleItem.Name });
            idx++;
        });

        return result;
    }

    return [];
}
